"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Highlight = exports.CardContentContainer = exports.CardContainer = exports.CardHoverOverlay = exports.CardOverlay = exports.CardBg = exports.BgContainer = exports.Card = exports.HighlightWave = exports.LoadedContentContainer = exports.PlaceholderLoadingContainer = exports.ShimmerContainerRight = exports.ShimmerContainerLeft = exports.ShimmerContainerTop = exports.ShimmerIcon = exports.ShimmerBox = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _polished = require("polished");

var _knotchincWebReactComponentsUtils = require("@bit/knotchinc.web-react-components.utils.styled-helpers");

var _emptyContentCard = _interopRequireDefault(require("./assets/emptyContentCard.svg"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _templateObject23() {
  var data = _taggedTemplateLiteral(["\n    background-position: 80% 0;\n    opacity: 1;\n  "]);

  _templateObject23 = function _templateObject23() {
    return data;
  };

  return data;
}

function _templateObject22() {
  var data = _taggedTemplateLiteral(["\n  background: ", ";\n  border-radius: 10px;\n  width: 100%;\n  height: 100%;\n  z-index: 2;\n  position: absolute;\n  top: 0;\n  right: 0;\n  transition: all .6s ease;\n  transition-delay: .5s;\n  opacity: 0;\n  background-size: 200% 200%;\n  background-position: 0 0;\n\n  ", ";\n"]);

  _templateObject22 = function _templateObject22() {
    return data;
  };

  return data;
}

function _templateObject21() {
  var data = _taggedTemplateLiteral(["\n    ", " {\n      opacity: 0;\n    }\n    ", " {\n      opacity: 1;\n    }\n  "]);

  _templateObject21 = function _templateObject21() {
    return data;
  };

  return data;
}

function _templateObject20() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  text-align: left;\n  color: white;\n  ", "\n"]);

  _templateObject20 = function _templateObject20() {
    return data;
  };

  return data;
}

function _templateObject19() {
  var data = _taggedTemplateLiteral(["\n    &:hover {\n      z-index: 2;\n\n      ", " {\n        transform: translateY(-5px) scale(1.01);\n        box-shadow: 0 2px 20px rgba(0, 0, 0, 0.3);\n      }\n\n      ", " {\n        opacity: 1;\n      }\n    }"]);

  _templateObject19 = function _templateObject19() {
    return data;
  };

  return data;
}

function _templateObject18() {
  var data = _taggedTemplateLiteral(["{\n    pointer-events: none;\n  }"]);

  _templateObject18 = function _templateObject18() {
    return data;
  };

  return data;
}

function _templateObject17() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  display: inline-block;\n  padding: 8px;\n  width: ", ";\n  height: ", ";\n  -webkit-transform: translate3d(0, 0, 0);\n  cursor: ", ";\n  ", ";\n  max-width: 1214px;\n  z-index: 1;\n\n  ", "\n"]);

  _templateObject17 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  ", "\n  width: 100%;\n  height: 100%;\n  transition: all .6s cubic-bezier(0.25, 1.03, 0.26, 0.95);\n  opacity: 0;\n  border-radius: 10px;\n  overflow: hidden;\n"]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  ", "\n  width: 100%;\n  height: 100%;\n  border-radius: 10px;\n  overflow: hidden;\n"]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n  background-color: #ffffff;\n  background-image: url('", "');\n  background-position: center center;\n  background-repeat: no-repeat;\n  opacity: 0.8;\n  width: 100%;\n  height: 100%;\n  border-radius: 10px;\n  overflow: hidden;\n"]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  border-radius: 10px;\n  overflow: hidden;\n  transform: translate3d(0,0,0);\n  transform-style: preserve-3d;\n  z-index: 1;\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  border-radius: 10px;\n  width: 100%;\n  height: 100%;\n  position: relative;\n  color: white;\n  transition: all .8s cubic-bezier(0.25, 1.03, 0.26, 0.95);\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  pointer-events: none;\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  border-radius: 10px;\n  content: '';\n  padding: 2px;\n  z-index: -1;\n  background: ", ";\n  opacity: .5;\n  animation: ", " .8s cubic-bezier(0, 1.1, 0.58, 1) forwards;\n  animation-delay: .2s;\n  animation-iteration-count: 1;\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  0% {\n    transform: scale(1);\n    opacity: .5;\n  }\n\n  100% {\n    transform: scale(1.1);\n    opacity: 0;\n  }\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  opacity: 0;\n  z-index: 2;\n  transition: all .2s ease;\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  z-index: 2;\n  opacity: 1;\n  transition: all .2s ease;\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: auto;\n  right: 0;\n  bottom: 0;\n  left: auto;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  margin-bottom: 12px;\n  position: absolute;\n  top: auto;\n  left: 0;\n  bottom: 0;\n  right: 0;\n\n  &:last-child() {\n    margin-top: 25px;\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  max-width: 40%;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  border-radius: 50%;\n  width: ", ";\n  height: ", ";;\n  ", "\n\n  &:first-child {\n    margin-right: 5px;\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  width: ", ";\n  height: ", ";;\n  margin-top: 12px;\n  border-radius: 12px;\n  ", "\n  max-width: 100%;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    animation: ", " 4s infinite forwards;\n    background: linear-gradient(to right, ", ");\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    0% {\n      background-position: ", ";\n    }\n    100% {\n      background-position: ", ";\n    }\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var fallbackGradient = 'linear-gradient(360deg, rgba(0, 0, 0, 0.9) 0%, rgba(0, 0, 0, 0.4) 100%)';
/* ANIMATION */

var shimmerBackground = function shimmerBackground(width) {
  var bgSize = width ? "".concat(width, " 0") : '250px 0';
  var bgSizeNeg = "-".concat(bgSize);
  return (0, _styledComponents.keyframes)(_templateObject(), bgSizeNeg, bgSize);
};

var shimmer = function shimmer(width, theme) {
  var gradient = "".concat((0, _polished.transparentize)(0.45, theme.colors.palette[2]), " 4%, ").concat((0, _polished.transparentize)(0.55, theme.colors.palette[4]), " 25%, ").concat((0, _polished.transparentize)(0.45, theme.colors.palette[2]), " 36%");
  return (0, _styledComponents.css)(_templateObject2(), shimmerBackground(width), gradient);
};
/* LOADING BOX */


var ShimmerBox = _styledComponents["default"].div(_templateObject3(), function (_ref) {
  var width = _ref.width;
  return width || '100%';
}, function (_ref2) {
  var height = _ref2.height;
  return height || '20px';
}, function (_ref3) {
  var width = _ref3.width,
      theme = _ref3.theme;
  return shimmer(width, theme);
});

exports.ShimmerBox = ShimmerBox;

var ShimmerIcon = _styledComponents["default"].div(_templateObject4(), function (_ref4) {
  var width = _ref4.width;
  return width || '25px';
}, function (_ref5) {
  var height = _ref5.height;
  return height || '25px';
}, function (_ref6) {
  var width = _ref6.width,
      theme = _ref6.theme;
  return shimmer(width, theme);
});

exports.ShimmerIcon = ShimmerIcon;

var ShimmerContainerTop = _styledComponents["default"].div(_templateObject5());

exports.ShimmerContainerTop = ShimmerContainerTop;

var ShimmerContainerLeft = _styledComponents["default"].div(_templateObject6());

exports.ShimmerContainerLeft = ShimmerContainerLeft;

var ShimmerContainerRight = _styledComponents["default"].div(_templateObject7());

exports.ShimmerContainerRight = ShimmerContainerRight;

var PlaceholderLoadingContainer = _styledComponents["default"].div(_templateObject8(), (0, _knotchincWebReactComponentsUtils.absFull)());

exports.PlaceholderLoadingContainer = PlaceholderLoadingContainer;

var LoadedContentContainer = _styledComponents["default"].div(_templateObject9(), (0, _knotchincWebReactComponentsUtils.absFull)());

exports.LoadedContentContainer = LoadedContentContainer;
var shockwave = (0, _styledComponents.keyframes)(_templateObject10());

var HighlightWave = _styledComponents["default"].div(_templateObject11(), function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.palette[7];
}, shockwave);
/*  BASE CARD  */


exports.HighlightWave = HighlightWave;

var Card = _styledComponents["default"].div(_templateObject12(), (0, _knotchincWebReactComponentsUtils.absFull)());
/*  BACKGROUND  */


exports.Card = Card;

var BgContainer = _styledComponents["default"].div(_templateObject13(), (0, _knotchincWebReactComponentsUtils.absFull)());

exports.BgContainer = BgContainer;

var CardBg = _styledComponents["default"].div(_templateObject14(), _emptyContentCard["default"]);
/*  OVERLAY  */


exports.CardBg = CardBg;

var CardOverlay = _styledComponents["default"].div(_templateObject15(), (0, _knotchincWebReactComponentsUtils.absFull)(), function (props) {
  return props.placeholderLoading ? (0, _polished.linearGradient)({
    colorStops: [(0, _polished.transparentize)(0.1, props.theme.colors.palette[1]), (0, _polished.transparentize)(0.4, props.theme.colors.palette[4])],
    toDirection: '45deg',
    fallback: fallbackGradient
  }) : (0, _polished.linearGradient)({
    colorStops: [(0, _polished.transparentize)(0.1, '#000000'), (0, _polished.transparentize)(0.8, '#000000')],
    toDirection: '45deg',
    fallback: fallbackGradient
  });
});

exports.CardOverlay = CardOverlay;

var CardHoverOverlay = _styledComponents["default"].div(_templateObject16(), (0, _knotchincWebReactComponentsUtils.absFull)(), function (props) {
  return !props.placeholderLoading && (0, _polished.linearGradient)({
    colorStops: [(0, _polished.transparentize)(0.1, props.theme.colors.palette[1]), (0, _polished.transparentize)(0.4, props.theme.colors.palette[4])],
    toDirection: '45deg',
    fallback: fallbackGradient
  });
});

exports.CardHoverOverlay = CardHoverOverlay;

var CardContainer = _styledComponents["default"].div(_templateObject17(), function (props) {
  return props.width || '300px';
}, function (props) {
  return props.height || '380px';
}, function (_ref8) {
  var placeholderLoading = _ref8.placeholderLoading;
  return placeholderLoading ? 'default' : 'pointer';
}, function (_ref9) {
  var placeholderLoading = _ref9.placeholderLoading;
  return placeholderLoading && (0, _styledComponents.css)(_templateObject18());
}, function (_ref10) {
  var placeholderLoading = _ref10.placeholderLoading;
  return !placeholderLoading && (0, _styledComponents.css)(_templateObject19(), Card, CardHoverOverlay);
});
/*  CARD CONTENT  */


exports.CardContainer = CardContainer;

var CardContentContainer = _styledComponents["default"].div(_templateObject20(), (0, _knotchincWebReactComponentsUtils.absFull)('30px', '25px', '30px', '25px'), function (_ref11) {
  var placeholderLoading = _ref11.placeholderLoading;
  return !placeholderLoading && (0, _styledComponents.css)(_templateObject21(), PlaceholderLoadingContainer, LoadedContentContainer);
});

exports.CardContentContainer = CardContentContainer;

var Highlight = _styledComponents["default"].div(_templateObject22(), function (_ref12) {
  var theme = _ref12.theme;
  return "linear-gradient(50.8deg, rgba(45, 139, 255, 0) 66.1%, ".concat(theme.colors.palette[7], " 96.46%)");
}, function (_ref13) {
  var shown = _ref13.shown;
  return shown && (0, _styledComponents.css)(_templateObject23());
});

exports.Highlight = Highlight;

//# sourceMappingURL=styled.js.map